// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"az_UM","question":"az_VM"};